module.exports = __webpack_public_path__ + "img/light_lhc.gm.9a20170.png";